export default __webpack_public_path__ + "static/media/social1.b0261e6b.webp";